import { Box } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { classes } from "./error-placeholder.styles";

export const ErrorPlaceholder = ({ message }: { message: string }) => {
  return (
    <Box sx={classes.root}>
      <Box>
        <ErrorOutlineIcon color="error" sx={classes.icon} />
      </Box>
      <Box sx={classes.message}>{message}</Box>
    </Box>
  );
};
